import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ObservationTypesDictionaryItem } from '../objects/dictionaries/observationTypesDictionaryItem';
import { SourcesDictionaryItem } from '../objects/dictionaries/sourcesDictionaryItem';
import { BaseApi, BaseDictionaryItem, Endpoint, GetDictionary } from '../public_api';
import { DictionaryType } from './dictionaryType.enum';
import { EvHttpResponseHandler } from './evHttpResponseHandler';
import { AddObservation } from './observations/addObservation';
import { GetObservationDetails } from './observations/getObservationDetails';
import { GetObservations } from './observations/getObservations';
import { GetObservationsForExport } from './observations/getObservationsForExport';

@Injectable()
export class ApiService extends BaseApi {
  private readonly USE_LIVE_API = true;

  private _dictionaries = [
    new GetDictionary(DictionaryType.COUNTRIES, this.USE_LIVE_API).setDefaultParams({
      path: 'countries',
      typeObj: BaseDictionaryItem,
    }),
    new GetDictionary(DictionaryType.COUNTRIES_USED, this.USE_LIVE_API).setDefaultParams({
      path: 'countries-used',
      typeObj: BaseDictionaryItem,
    }),
    new GetDictionary(DictionaryType.OBSERVATION_TYPES, this.USE_LIVE_API).setDefaultParams({
      path: 'observation-types',
      typeObj: ObservationTypesDictionaryItem,
    }),
    new GetDictionary(DictionaryType.KEYWORDS, this.USE_LIVE_API).setDefaultParams({
      path: 'keywords',
      typeObj: BaseDictionaryItem,
    }),
    new GetDictionary(DictionaryType.KEYWORDS_USED, this.USE_LIVE_API).setDefaultParams({
      path: 'keywords-used',
      typeObj: BaseDictionaryItem,
    }),
    new GetDictionary(DictionaryType.PROPERTIES, this.USE_LIVE_API).setDefaultParams({
      path: 'properties',
      typeObj: BaseDictionaryItem,
    }),
    new GetDictionary(DictionaryType.SOURCES, this.USE_LIVE_API).setDefaultParams({
      path: 'sources',
      typeObj: SourcesDictionaryItem,
    }),
  ];

   
  public readonly endpoints: Record<string, Record<string, Endpoint<any, any>>> = {
    observations: {
      get: new GetObservations(this.USE_LIVE_API),
      forExport: new GetObservationsForExport(this.USE_LIVE_API),
      details: new GetObservationDetails(this.USE_LIVE_API),
      add: new AddObservation(this.USE_LIVE_API),
    },
  };

  constructor(httpClient: HttpClient, injector: Injector) {
    super(injector, httpClient, new EvHttpResponseHandler(injector), environment.apiBaseUrl);
    this.addDictionaries(this._dictionaries);

    // add endpoints
     
    Object.values(this.endpoints).forEach((group: Record<string, Endpoint<any, any>>) => {
      this.addEndpoints(Object.values(group));
    });
  }
}
